"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dropdown_1 = require("primereact/dropdown");
const utils_1 = require("primereact/utils");
const react_1 = require("react");
const Dropdown = (props) => {
    const handleChange = (0, react_1.useCallback)((event) => {
        if (props.onChange) {
            props.onChange(event.value);
        }
    }, [props.onChange]);
    return ((0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, { ...props, className: (0, utils_1.classNames)('dropdown-sm', props.className, {
            'w-full': props.isFullWidth,
            'p-invalid': props.invalid,
        }), optionLabel: 'label', onChange: handleChange }));
};
exports.Dropdown = Dropdown;
exports.Dropdown.defaultProps = {
    isFullWidth: true,
    editable: false,
    disabled: false,
    loading: false,
};
